import graphql__73b13e11b6945bb02cdf from "./__generated__/ComplexMenuDesktopVerticalSubmenuItem_navigationItem.graphql.js";import { useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import ButtonLink from "../../../Buttons/ButtonLink";
import { useNavigationItemIsActive, useComplexMenuContext } from "../ComplexMenuContext";

const ComplexMenuDesktopVerticalSubmenuItem = ({ navigationItem }) => {
  const item = useFragment(
    ComplexMenuDesktopVerticalSubmenuItem_navigationItem,
    navigationItem
  );

  const { name, url } = item;
  const { isActive } = useNavigationItemIsActive(item);
  const { setHoveredSubMenuId } = useComplexMenuContext();

  const linkClassName = classNames(
    "complex-menu-vertical-submenu-item-link",
    "d-block",
    "padding-x-sm",
    "padding-y-xs",
    "text-primary-on-white-hover",
    {
      active: isActive
    }
  );

  const handleClick = useCallback(() => {
    // Close submenu when clicking on an item
    setHoveredSubMenuId(null);
  }, [setHoveredSubMenuId]);

  return (
    <li className="complex-menu-vertical-submenu-item">
      <ButtonLink
        href={url}
        className={linkClassName}
        label={name}
        onClick={handleClick}
      />
    </li>
  );
};

const ComplexMenuDesktopVerticalSubmenuItem_navigationItem = graphql__73b13e11b6945bb02cdf;

export default ComplexMenuDesktopVerticalSubmenuItem;
